import React from 'react';
import '../src/app.scss';
import { photos } from "./components/photos";
import ImagesCar from "./components/images"
import Contact from "./components/contact";
import MyTime from './components/timeline';
import "animate.css/animate.min.css";
import ScrollAnimation from 'react-animate-on-scroll';


const BasicRows = () => <ImagesCar photos={photos} />
function App() {
  return (
    
    <div className="App">
        <header className = "App-header">
          <button className = "hover-button1">
            <div className='d1'>
            <div className="d6"></div>
            <div className="d3"></div>
            <div className="d4"></div>
            <div className="d5"></div>
            <div className="d2"></div>
            <div className="d11"></div>
            <div className="d7"></div>
          </div> 
          </button>
          <div className="herotittle-wrapper">
            <h1>Alexeev Evghenii</h1>
            <h2 className="hero-h2">I do care about OUR success..</h2>
            <ScrollAnimation animateIn="fadeIn">
              <Contact/>
            </ScrollAnimation>
          </div>
        </header>
        
          <MyTime/>
        
        <div className="myworks">
          <h1>Work Gallery</h1>
        </div>
        <ScrollAnimation animateIn="fadeIn">
          <BasicRows/>
        </ScrollAnimation>
        <footer>
          2019 All rights Reserved
        </footer>
    </div>
        
    
  );
}

export default App;
